module.exports = __webpack_public_path__ + "static/media/we-provide.aef90d7c.svg";